import get from 'lodash/get'

import { fetchCollection, updateResource } from './index'

import { servicingVersionsSchema } from '../schemas'

export const SERVICING_VERSIONS_REQUEST = 'SERVICING_VERSIONS_REQUEST'
export const SERVICING_VERSIONS_SUCCESS = 'SERVICING_VERSIONS_SUCCESS'
export const SERVICING_VERSIONS_FAILURE = 'SERVICING_VERSIONS_FAILURE'

export const SERVICING_VERSION_UPDATE_REQUEST = 'SERVICING_VERSION_UPDATE_REQUEST'
export const SERVICING_VERSION_UPDATE_SUCCESS = 'SERVICING_VERSION_UPDATE_SUCCESS'
export const SERVICING_VERSION_UPDATE_FAILURE = 'SERVICING_VERSION_UPDATE_FAILURE'

export function fetchServicingVersionsForTechInContract(status, query) {
  return fetchCollection({
    url: `/servicing_versions/${status}`,
    query,
    key: 'servicingVersions',
    schema: servicingVersionsSchema,
    actions: [
      SERVICING_VERSIONS_REQUEST,
      SERVICING_VERSIONS_SUCCESS,
      SERVICING_VERSIONS_FAILURE
    ],
    responseInterceptor: (response) => ({ ...response, ...query })
  })
}

export function fetchUnsatisfactoryServicingVersions(technicianId, contractId) {
  return (dispatch, getState) => {
    return dispatch(fetchServicingVersionsForTechInContract('unsatisfactory', { technicianId, contractId }))
  }
}

export function updateServicingVersion (servicingVersionId, data) {
   return (dispatch) => dispatch(
     updateResource({
      url: `/servicing_versions/${servicingVersionId}`,
      key: 'servicingVersion',
      schema: servicingVersionsSchema,
      data,
      actions: [ SERVICING_VERSION_UPDATE_REQUEST, SERVICING_VERSION_UPDATE_SUCCESS, SERVICING_VERSION_UPDATE_FAILURE ]
    })
  )
}



// WEBPACK FOOTER //
// ./src/actions/servicing-versions.js